<template lang="pug">
base-section#news-carousel
  base-page-content
    .news-carousel-shell
      .news-carousel-copy
        base-display-title(:title='t("pages.articles.latest")', size='compact', tone='accent')
        h2.news-carousel-title {{ t('pages.articles.carouselTitle') }}
        p.news-carousel-body {{ t('pages.articles.carouselBody') }}
      news-carousel(:articles='articles')
</template>

<script setup>
defineOptions({
  name: 'NewsCarouselSection',
})

const props = defineProps({
  articles: {
    type: Array,
    required: true,
  },
})

const { t } = useI18n()
</script>

<style scoped>
#news-carousel {
  background:
    radial-gradient(
      circle at top right,
      rgba(0, 192, 216, 0.1),
      transparent 28rem
    ),
    linear-gradient(180deg, var(--surface-soft) 0%, var(--surface-page) 100%);
}

.news-carousel-shell {
  display: grid;
  gap: 1rem;
  padding: 1.2rem;
  border: 1px solid var(--border-default);
  background: var(--surface-card);
  box-shadow: var(--shadow-soft);
  border-radius: var(--radius-md);
}

.news-carousel-copy {
  display: grid;
  gap: 0.65rem;
  max-width: 42rem;
}

.news-carousel-title {
  margin: 0;
  font-size: clamp(2.1rem, 3.4vw, 3.3rem);
  line-height: 0.94;
  letter-spacing: -0.05em;
}

.news-carousel-body {
  margin: 0;
  color: var(--color-text);
}

@media (max-width: 760px) {
  .news-carousel-shell {
    padding: 0.9rem;
  }
}
</style>
